import { onBackgroundMessage } from "firebase/messaging/sw";
import { initializeApp } from "firebase/app";
import { getMessaging, getToken, onMessage } from "firebase/messaging";
import { $, Backbone, Foundation } from "../../vendor";

const firebaseConfig: {
  apiKey: string;
  authDomain: string;
  projectId: string;
  storageBucket: string;
  messagingSenderId: string;
  appId: string;
} = {
  apiKey: /*process.env.apiKey,*/ "AIzaSyBlio0sGKOlbxVSZr16tpDRJZz1QQOjVdo",
  authDomain: /*process.env.authDomain,*/ "ib-12drive.firebaseapp.com",
  projectId: /*process.env.projectId,*/ "ib-12drive",
  storageBucket: /*process.env.storageBucket,*/ "ib-12drive.appspot.com",
  messagingSenderId: /*process.env.messagingSenderId,*/ "424246490748",
  appId: /*process.env.appId*/ "1:424246490748:web:2e87dd00b31e48fde67bf9",
};

export const usePush: boolean = false;

// Initialize Firebase
export const firebaseApp: any = initializeApp(firebaseConfig);
export const messaging: any = getMessaging(firebaseApp);
// getOrRegisterServiceWorker function is used to try and get the service worker if it exists, otherwise it will register a new one.
export const getOrRegisterServiceWorker: () => Promise<ServiceWorkerRegistration> =
  (): Promise<ServiceWorkerRegistration> => {
    if ("serviceWorker" in navigator && typeof window.navigator.serviceWorker !== "undefined") {
      return window.navigator.serviceWorker
        .getRegistration("/firebase-push-notification-scope")
        .then((serviceWorker) => {
          if (serviceWorker) {
            console.log("return already registered serviceWorker");
            return serviceWorker;
          }
          console.log("register a serviceWorker");
          return window.navigator.serviceWorker.register("/firebase-messaging-sw.js", {
            scope: "/firebase-push-notification-scope",
          });
        });
    }
    throw new Error("The browser doesn`t support service worker.");
  };

// getFirebaseToken function generates the FCM token
export const getFirebaseToken: () => Promise<unknown> = async (): Promise<unknown> => {
  try {
    const messagingResolve: any = await messaging;
    if (messagingResolve) {
      return getOrRegisterServiceWorker().then((serviceWorkerRegistration) => {
        console.log("serviceWorkerRegistration", serviceWorkerRegistration);
        return new Promise(
          (
            resolve: (value: PromiseLike<unknown> | unknown) => void,
            reject: (reason?: any) => void,
          ) => {
            getToken(messagingResolve, {
              vapidKey:
                /*process.env.REACT_APP_FB_VAPID_KEY,*/ "BLxFkFSFG0a2IYR_9lZdxI0wV4-d58yIuR32HAAuwPo0yHfcSiaXiPjYAhynfdcmlYVzJyrGn6zWOpkWt33oD6A",
              serviceWorkerRegistration,
            }).then((token: string) => {
              console.log("Firebase Token: " + token);
              console.log(navigator.userAgent);
              const SubmitTokenModel = Backbone.Model.extend({
                urlRoot: "/users/storeToken/" + token + "/" + btoa(navigator.userAgent),
              });

              const submitTokenModel: any = new SubmitTokenModel();

              submitTokenModel.save(null, {
                type: "GET",
                success(model: any, response: any): void {
                  if (response.success === true) {
                    console.log("token successfully stored");
                  } else {
                    console.log("error storing token");
                  }
                },

                error(model: any, reponse: any): void {
                  console.log("error storing token");
                },
              });
            });
            return true;
          },
        );
      });
    }
  } catch (error: any) {
    console.log("An error occurred while retrieving token. ", error);
  }
};

/*export const onMessageListener = (async () => {
    const messagingResolve = await messaging;
    if (messagingResolve) {
        onMessage(messagingResolve, (payload) => {
            console.log(payload)
        });
    }
})();*/

export const onMessageListener = () =>
  new Promise((resolve) => {
    onMessage(messaging, (payload) => {
      resolve(payload);
    });
  });
/*
onBackgroundMessage(messaging, (payload) => {
    console.log('[firebase-messaging-sw.js] Received background message ', payload);
    // Customize notification here
    const notificationTitle = 'Background Message Title';
    const notificationOptions = {
        body: 'Background Message body.',
        icon: '/firebase-logo.png'
    };

    self.registration.showNotification(notificationTitle,
        notificationOptions);
});*/
export const notifyMe = () => {
  if (window.Notification.permission === "granted" || window.Notification.permission === "denied") {
    //do something
    return true;
  } else if (window.Notification.permission === "default") {
    new Foundation.Reveal($(".inb-ask-permission")).open();
  }

  $("#allow-push-notification").click(function () {
    // Opera 8.0+

    // @ts-ignore
    let isOpera =
      (!!window.opr && !!opr.addons) || !!window.opera || navigator.userAgent.indexOf(" OPR/") >= 0;

    // Firefox 1.0+
    // @ts-ignore
    let isFirefox = typeof InstallTrigger !== "undefined";

    // Safari 3.0+ "[object HTMLElementConstructor]"
    // @ts-ignore
    let isSafari =
      /constructor/i.test(window.HTMLElement) ||
      (function (p) {
        return p.toString() === "[object SafariRemoteNotification]";
      })(!window["safari"] || (typeof safari !== "undefined" && window["safari"].pushNotification));

    // Internet Explorer 6-11
    // @ts-ignore
    let isIE = /*@cc_on!@*/ false || !!document.documentMode;

    // Edge 20+
    // @ts-ignore
    let isEdge = !isIE && !!window.StyleMedia;

    // Chrome 1 - 79
    // @ts-ignore
    let isChrome = !!window.chrome && (!!window.chrome.webstore || !!window.chrome.runtime);

    // Edge (based on chromium) detection
    let isEdgeChromium = isChrome && navigator.userAgent.indexOf("Edg") != -1;

    // Blink engine detection
    let isBlink = (isChrome || isOpera) && !!window.CSS;
    if (isFirefox) {
      $("#img-firefox").removeClass("hide");
    }
    if (isEdge) {
      $("#img-edge").removeClass("hide");
    }
    if (isChrome) {
      $("#img-chrome").removeClass("hide");
    }
    if (isOpera) {
      $("#img-opera").removeClass("hide");
    }
    $(".inb-ask-permission").hide();

    window.Notification.requestPermission().then((permission) => {
      // If the user accepts, let's create a notification
      if (permission === "granted") {
        getFirebaseToken().then((firebaseToken) => {
          if (firebaseToken) {
            console.log(firebaseToken);
            return true;
          }
        });
      } else {
        return true;
      }
    });
  });
  $("#close-push-notification").click(function () {
    $(".inb-ask-permission").hide();
    return true;
  });

  return true;
};
